import {  AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { UserData } from '../../userData';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SelectedCell } from '../../common/selected-cell';
import { MccService } from '../../mcc.service';
import { UserService } from '../../user.service';
import { DlrService } from '../dlr.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserAuditV2Service } from '../../reports/user-audit-updated/user-audit-v2.service';
import { ColumnsOrdersService } from '../../common/columns-orders.service';
import { memoize } from '../../common/memoize-decorator';
import { ResizeEvent } from 'angular-resizable-element';
import copy from 'copy-to-clipboard';
import { SnackBarComponent } from '../../snack-bar/snack-bar.component';
import { map, startWith } from 'rxjs/operators';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import moment from 'moment';
import { saveAs                              } from 'file-saver';

@Component({
  selector: 'app-dlr-policies',
  templateUrl: './dlr-policies.component.html',
  styleUrls: ['./dlr-policies.component.scss']
})
export class DlrPoliciesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('fileUpload') fileUpload: ElementRef;
  @Input() tabCode: string;
  /** sort variable for Rates */
  @ViewChild('sortRoutes', { static: true}) sortRoutes: MatSort;
  @ViewChild('dlrPaginator', { static: true}) dlrPaginator: MatPaginator;

  @ViewChild('tableElem', { static: true }) tableElem;

  // @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('target') targetElement: any;

  @ViewChild(MatMenuTrigger, {static: true}) menu: MatMenuTrigger;

  isScrolling;

  drawingSquare = 0;

  /** datasource for Rates table */
  dataSourceDlr = new MatTableDataSource();/* new TableVirtualScrollDataSource(); */
  allData         = [];

  pageName = 'DLR Policies';

  displayedColumns: string[] = [];
  columns: any[] = [];

  filterForm: FormGroup;

  /** FormControl for MCC  */
  fcMCC         = new FormControl(null);

  fcSid         = new FormControl(null);
  fcContent     = new FormControl(null);

  selectedId:      number;
  selectedElement: string;
  savedOldValue:   string;

  request = {};

  countriesSubscription: Subscription;

  filterSubscriptions:   Subscription[] = [];
  basicConf: Subscription;

  clipboard: string;
  menuX = 0;
  menuY = 0;

  providers:             any[];
  loadingData:           number;
  emptyData:             boolean;
  showPaginator:         boolean;
  providerSelectStatus:  boolean;
  user:                  UserData;

  dialogRates:           MatDialogRef<any>;
  dialogConfirmation:    MatDialogRef<any>;
  dialogDlr:             MatDialogRef<any>;

  filteredCountries:     Observable<any[]>;
  filteredAccounts:      Observable<any[]>;

  countries:             any[] = [];

  minDate:               Date;
  selectAll:             boolean;
  spinnerRef:            MatDialogRef<any>;

  selectedMCCs:          string[] = [];
  selectedMNCs:          string[] = [];

  accountsForSelection            = [];
  mccsForSelection                = [];
  mncsForSelection                = [];

  policyData                      = [];

  tabData:                any;
  tabFilters:             any;

  tabDataAccounts:        any;
  tabDataCountries:       any;
  tabDataSource:          any;
  tabDataProviders:       any;
  tabDataPolicy:          any;

  totalRecords:           number;

  destroy$:               Subject<boolean> = new Subject<boolean>();
  pageEvent:              PageEvent;

  fValues = [
    {text: 'All', value: null},
    {text: 'Yes', value: 1   },
    {text: 'No' , value: 0   }
  ];

  refreshTexts = 0;

  selectedCount = 0;

  initialized = false;
  isBulkyLoad = true;

  isMarkKeyTraffic = 0;
  isAllChecked = 0;

  pageSize = 50;
  pageIndex = 0;

  position: any;
  loadedPosition: any;
  sortState: any;

  hideForm = true;
  chromeTabs = true;

  mouseDown = false;
  selX: number;
  selY: number;
  selectedCellsData: SelectedCell[] = [];
  startSelectionParams: SelectedCell = null;

  loadingAccountsData = false;
  timeouts = [];

  criteria: any;

  // private ctx: CanvasRenderingContext2D;


  constructor(filForm: FormBuilder, private dialog: MatDialog,
              private mccService: MccService, public cdr: ChangeDetectorRef,
              private userService: UserService,
              private dlrService: DlrService, private snackBar: MatSnackBar,
              private userAuditV2Service: UserAuditV2Service, private columnsOrderService: ColumnsOrdersService) {


    if (this.chromeTabs) {
      this.tabCode = this.pageName;
    }

    this.setCommonSubscriptions();

    this.filterForm = filForm.group({
      fcMCC           : this.fcMCC,
      fcSid           : this.fcSid,
      fcContent       : this.fcContent
    });

    this.loadingData   = 0;
    this.showPaginator = true;

    this.user = this.userService.getUserData();

    this.resetFilter();
  }

  @memoize()
  checkSmallScreen() {
    if (window.innerWidth <= 1280) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit(): void {
    // this.ctx = this.canvas.nativeElement.getContext('2d');
    // this.ctx.canvas.width = 0;
    // this.ctx.canvas.height = 0;



    this.columnsOrderService.createBasicConfObservable(this.pageName);
    this.basicConf = this.columnsOrderService.getBasicColumnsConfig().subscribe(conf => {
      this.initColumns(conf);
    });

    this.dataSourceDlr.sort = this.sortRoutes;
    this.dataSourceDlr.paginator = this.dlrPaginator;

    this.hideForm = false;
    this.basicConf.unsubscribe();

  }

  getColWidth(name) {
    const found = this.columns.find(col => col.name === name);
    return found ? found.width + 'px' : 0 + 'px';
  }

  setColWidth(name, width) {
    const found = this.columns.find(col => col.name === name);
    if (found) {
      this.columnsOrderService.setColWidth(this.tabCode, name, width);
    }
  }

  onResizeEnd(event: ResizeEvent, columnName): void {
    if (event.edges.right) {
      const cssValue = event.rectangle.width;
      const columnElts: any = document.getElementsByClassName('mat-column-' + columnName);
      let flag = 0;
      for (const colEl of columnElts) {
        const currentEl = colEl as HTMLDivElement;
        currentEl.style.width = cssValue  + 'px';
        if (flag === 0) {
          this.setColWidth(columnName, cssValue);
          flag = flag + 1;
        }
      }
    }
  }

  async initColumns(basicConf?) {

      this.columns = this.columnsOrderService.getColumnsOrder(this.tabCode);
      if (this.columns && this.columns.length) {
        this.displayedColumns = this.columns
          .filter(it => it.visible === true)
          .map(it => it.name);
      } else {
        if (basicConf) {
          this.displayedColumns = basicConf.columns
            .filter(it => it.visible === true)
            .map(it => it.name);
          this.columns = basicConf.columns;
          this.columnsOrderService.createConf(this.tabCode, basicConf.columns);
        }
      }

  }

  checkSelectAll(src: string, action: boolean) {

    if (src === 'click') {
      this.dataSourceDlr.connect().value.forEach((element: any) => {
        element.selected = action;
      });
    } else {
      this.isAllChecked = action ? 1 : 0;
      this.dataSourceDlr.filteredData.forEach((element: any) => {
        element.selected = action;
      });

      if (action === false) {

        this.selectedCellsData = [];
        this.startSelectionParams = null;

      }
    }
    this.setSelectedCount();
    this.mouseDown = false;
    this.cdr.detectChanges();
  }

  scrolling(e) {
    if (this.loadedPosition && (this.loadedPosition.loadedLeft === false || this.loadedPosition.loadedTop === false)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    } else {
      window.clearTimeout(this.isScrolling);
      // Set a timeout to run after scrolling ends
      this.isScrolling = setTimeout(() => {
        this.position = {
          left: this.tableElem.nativeElement.scrollLeft,
          top: this.tableElem.nativeElement.scrollTop,
          loadedLeft: false,
          loadedTop: false
        };
      }, 150);
    }

  }


  sortChange(e) {
    this.sortState = {
      direction: this.sortRoutes.direction,
      active: this.sortRoutes.active
    };
  }

  setSelectedCount(element?) {
    if (element) {
      element.selected = !(element.selected);
    }
    this.timeouts.push(setTimeout(() => {
      this.selectedCount    = this.getSelectedCount();
      this.cdr.detectChanges();
    }, 0));
  }

  getSelectedCount() {
    if (this.dataSourceDlr && this.dataSourceDlr.data) {
      return this.isAllChecked ? this.totalRecords : this.dataSourceDlr.data.filter((item: any) => item.selected === true).length;
    } else {
      return 0;
    }
  }

  // drawing(param, event) {
  //   if (param) {
  //     this.mouseDown = param;
  //
  //     this.ctx.canvas.width = this.targetElement.nativeElement.offsetWidth;//window.innerWidth/* table.clientWidth*/;
  //     this.ctx.canvas.height = window.innerHeight - 130 - 70 - 48 - 12 ;//window.innerHeight/*  table.clientHeight */;
  //
  //     this.ctx.fillStyle = 'rgba(46, 114, 176, 0.3)';
  //
  //     this.selX = event.layerX;
  //     this.selY = event.layerY;
  //   } else {
  //     if (this.drawingSquare > 25) {
  //       this.mouseDown = param;
  //     }
  //     this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  //     this.ctx.canvas.width = 0;
  //     this.ctx.canvas.height = 0;
  //   }
  // }

  mouseMoveTable(event) {
    if (this.mouseDown === true) {
      this.mouseDown = false;
    }
  }

  mouseMove(event) {
    if (this.mouseDown === true) {
      //this.ngZone.runOutsideAngular(() =>

      const x = event.layerX;//clientX - this.tableElem.nativeElement.offsetLeft + this.tableElem.nativeElement.scrollLeft;
      const y = event.layerY;//clientY - this.tableElem.nativeElement.offsetTop + this.tableElem.nativeElement.scrollTop - 40;

      //this.drawSelection(x, y);
      //);
    }
  }

  // drawSelection(w: number, h: number) {
  //   this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  //   this.ctx.fillRect(this.selX, this.selY, w - this.selX , h - this.selY);
  //   this.drawingSquare = Math.abs((w - this.selX) * (h - this.selY));
  // }

  handleCopy(event) {
    event.preventDefault();
    this.copyToClipboard();
  }

  copyToClipboard() {
    const str = this.selectedCellsData.length ?
      this.selectedCellsData.map(item => item.data).join(', ') : this.startSelectionParams.data;
    copy(str);
  }

  selectRow(row, event: MouseEvent, index) {
    if (event.shiftKey === false && this.startSelectionParams/*  && event.button === 0 */) {
      this.startSelectionParams = null;
    }
  }

  checkIfCellSelected(colName, index) {
    // console.count(colName + index);
    const found = this.selectedCellsData.findIndex(cell => cell.colName === colName && cell.rowIndex === index);

    if (this.startSelectionParams && this.startSelectionParams.colName === colName && this.startSelectionParams.rowIndex === index) {
      return 0;
    }

    return found;
  }

  selectCellStart(colName: string, cell: any, event: MouseEvent, index) {
    // event.preventDefault();
    if (event.button === 0 && event.shiftKey === false && event.ctrlKey === false) {
      // this.mouseDown = true;

      this.selectedCellsData = [];
      this.startSelectionParams = {
        rowIndex: index,
        colName,
        data: cell[colName]
      };

      //this.drawing(true, event);
    }
  }

  afterDrawing(colName: string, cell: any, event: MouseEvent, indexEnd) {
    if (this.mouseDown === false && this.drawingSquare > 25) {
      this.selectCellEnd(colName, cell, event, indexEnd);
    }
  }

  afterDrawingCell(colName: string, cell: any) {
    if (this.mouseDown === true && this.drawingSquare <= 25) {
      this.mouseDown = false;
      switch (colName) {

        default:
          break;
      }
    }
  }

  selectCellEnd(colName: string, cell: any, event: MouseEvent, indexEnd) {
    event.preventDefault();
    if (/* this.mouseDown === true && */this.drawingSquare > 25 && this.startSelectionParams !== null && event.button === 0) {

      if ((this.startSelectionParams.rowIndex !== indexEnd || this.startSelectionParams.colName !== colName) ) {

        const startInd = this.startSelectionParams.rowIndex < indexEnd ? this.startSelectionParams.rowIndex : indexEnd;
        const endInd = this.startSelectionParams.rowIndex < indexEnd ? indexEnd : this.startSelectionParams.rowIndex;

        for (let index = startInd; index <= endInd; index++) {
          const element: any = this.dataSourceDlr.connect().value[index];
          element.selected = true;

          const sti = this.displayedColumns.findIndex(col => col === this.startSelectionParams.colName);
          const eti = this.displayedColumns.findIndex(col => col === colName);
          const startColIndex = sti < eti ? sti : eti;
          const endColIndex = sti < eti ? eti : sti;

          for (let colIndex = startColIndex; colIndex <= endColIndex; colIndex++) {
            this.selectedCellsData.push({
              rowIndex: index,
              colName: this.displayedColumns[colIndex],
              data: element[this.displayedColumns[colIndex]]
            });
          }
        }
      }

    } else {
      if (event.shiftKey === true && this.startSelectionParams === null && event.button === 0) {

        this.selectedCellsData = [];
        this.startSelectionParams = {
          rowIndex: indexEnd,
          colName,
          data: cell[colName]
        };
      } else {
        if (event.ctrlKey === true  && event.button === 0) {
          cell.selected = true;
          const findIndex = this.checkIfCellSelected(colName, indexEnd);
          if (findIndex === -1) {
            this.selectedCellsData.push({
              rowIndex: indexEnd,
              colName,
              data: cell[colName]
            });
          } else {
            this.selectedCellsData.splice(findIndex, 1);
          }

        }

        if (event.shiftKey === true  && event.button === 0) {
          if (this.startSelectionParams) {

            const startInd = this.startSelectionParams.rowIndex < indexEnd ? this.startSelectionParams.rowIndex : indexEnd;
            const endInd = this.startSelectionParams.rowIndex < indexEnd ? indexEnd : this.startSelectionParams.rowIndex;

            for (let index = startInd; index <= endInd; index++) {
              const element: any = this.dataSourceDlr.connect().value[index];
              element.selected = true;

              const sti = this.displayedColumns.findIndex(col => col === this.startSelectionParams.colName);
              const eti = this.displayedColumns.findIndex(col => col === colName);
              const startColIndex = sti < eti ? sti : eti;
              const endColIndex = sti < eti ? eti : sti;

              for (let colIndex = startColIndex; colIndex <= endColIndex; colIndex++) {
                this.selectedCellsData.push({
                  rowIndex: index,
                  colName: this.displayedColumns[colIndex],
                  data: element[this.displayedColumns[colIndex]]
                });
              }
            }
          }
        }

        if (event.shiftKey === false && event.ctrlKey === false && event.button === 0) {
          this.selectedCellsData = [];
        }
      }
    }

    this.setSelectedCount();

    this.mouseDown = false;
    this.drawingSquare = 0;


  }

  changePageEvent(event?: PageEvent) {
    if (event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
    }
    if (event.pageIndex !== this.pageIndex) {
      this.pageIndex = event.pageIndex;
    }
    this.setSubscription();
  }

  ngAfterViewInit() {
    this.initialized = true;

    if (this.sortState) {
      this.restoreSort();
    }
    this.cdr.detectChanges();

    this.timeouts.push(setTimeout(() => {
      this.scrollToLoadedPosition();
      this.hideForm = false;

    }, 0));
  }

  checkValMCC(value) {
    if (this.selectedMCCs !== value) {
      this.selectedMCCs = value;
      //this.createMNCList(value);
    }
  }

  createMCCList() {
    this.mccsForSelection = [];
    this.countries.forEach(element => {
      const el = {
        display: element.country + ' - ' + element.mcc,
        value: element.mcc
      };
      this.mccsForSelection.push(el);
    });
  }

  getCountryFromId(id) {
    return this.countries.find(item => item.mcc === id) ? this.countries.find(item => item.mcc === id).country : '';
  }

  resetFilter() {

    this.filterForm.reset();

    this.filterForm.patchValue({
      fcMCC : null,
      fcSid : null,
      fcContent : null,
    });

    this.selectAll = false;

    this.destroy$.next(true);
  }

  async restoreSort() {
    this.timeouts.push(setTimeout(() => {
      if (this.sortRoutes && this.sortRoutes.active !== this.sortState.active
        && this.sortRoutes.direction !== this.sortState.direction) {
        this.sortRoutes.sort({ id: this.sortState.active, start: this.sortState.direction, disableClear: false });
        this.sortRoutes._stateChanges.next();
        this.restoreSort();
      } else {
      }
    }, 50));
  }

  scrollToLoadedPosition() {
    if (this.tableElem && this.loadedPosition) {
      if (this.tableElem.nativeElement.scrollLeft !== this.loadedPosition.left
        || this.tableElem.nativeElement.scrollTop !== this.loadedPosition.top) {
        this.tableElem.nativeElement.style.visibility = 'hidden';
        this.tableElem.nativeElement.scrollTop = this.loadedPosition.top;
        this.tableElem.nativeElement.scrollLeft = this.loadedPosition.left;
        this.tableElem.nativeElement.style.visibility = 'visible';
      }

      if (this.tableElem.nativeElement.scrollLeft === this.loadedPosition.left) {
        this.loadedPosition.loadedLeft = true;
      }

      if (this.tableElem.nativeElement.scrollTop === this.loadedPosition.top) {
        this.loadedPosition.loadedTop = true;
      }

      if (!this.loadedPosition.loadedLeft || !this.loadedPosition.loadedTop) {
        this.timeouts.push(setTimeout(() => {
          this.scrollToLoadedPosition();
        }, 50));
      }
    }

  }

  setCommonSubscriptions() {
    this.filterSubscriptions.push(this.mccService.getCountries().subscribe(res => {
      if (res) {
        this.countries = [{mcc: null, country: 'All'}].concat(res);

        this.filteredCountries = this.fcMCC.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      }
    }));
  }

  refreshData() {
    this.isAllChecked = 0;

    this.selectAll = false;
    this.setSubscription();
  }

  openSnackBar(message: Array<string>) {
    // this.snackBar.open(message);
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: message
    });
  }

  async prepareAccounts(accArray) {
    this.accountsForSelection = [];

    accArray.forEach(element => {
      const el = {
        // display: element.name,
        display: element.name + ' - ' + element.id,
        value: element.id,
        optimize: element.optimize
      };

      this.accountsForSelection.push(el);

    });

    if (accArray.length === this.accountsForSelection.length) {
      this.loadingAccountsData = false;
    }

  }

  getUTCTime(date: Date) {
    if (date) {
      return moment(date).utc().format('YYYY-MM-DD hh:mm a');
    } else {
      return '';
    }
  }

  setSubscription() {
    this.loadingData = 1;
    this.emptyData   = false;
    this.criteria    = {
      /* client_id   : this.fcClientAccount.value ? Number(this.fcClientAccount.value.replace(/.*\-\s/g, ''))  : null, */
      mcc         : this.fcMCC.value           ? Number(this.fcMCC.value          .replace(/\s-\s.*/g, '')) : null,
      sid_regex   : this.fcSid.value     || null,
      dest_regex  : this.fcContent.value || null,
      page        : Number(this.pageIndex + 1),
      pageSize    : Number(this.pageSize)
    };

    this.dlrService.getByCriteria(this.criteria).toPromise().then((response: any) => {
      if (response.body.data.length === 0) {
        this.emptyData = true;
      }

      this.dataSourceDlr.data = response.body.data;
      this.totalRecords       = response.body.total;
      this.loadingData        = 2;
    });
  }

  async addPolicy(){
    const { AddDlrPolicyComponent } = await import(
      /* webpackPrefetch: true */
      './add-dlr-policy/add-dlr-policy.component'
      );

    this.dialogDlr = this.dialog.open(AddDlrPolicyComponent, {
      width        : '900px',
      disableClose  : false,
      hasBackdrop: true,
      id           : 'AddDlrPolicy' + this.tabCode,
      data         : {
        policy : {},
        tab                         : this.tabCode,
        countries                   : this.countries,
        policyServiceFrom           : [],
        userAuditV2ServiceFrom      : this.userAuditV2Service,
        setPoliciesSubscriptionFrom : ()          => {},
        openSnackBarFrom            : (message)   => this.openSnackBar(message),
        showMessageFrom             : (mes, type) => { }
      }
    });

    this.filterSubscriptions.push(this.dialogDlr.afterClosed().subscribe(result => {
      this.setSubscription();
    }));
  }

  async editRegex(editType, policy) {
    const { AddDlrPolicyComponent } = await import(
      /* webpackPrefetch: true */
      './add-dlr-policy/add-dlr-policy.component'
      );

    this.dialogDlr = this.dialog.open(AddDlrPolicyComponent, {
      width        : '900px',
      disableClose  : false,
      hasBackdrop: true,
      id           : 'AddDlrPolicy' + this.tabCode,
      data         : {
        policy,
        editType,
        tab                         : this.tabCode,
        openSnackBarFrom            : (message)   => this.openSnackBar(message)
      }
    });

    this.filterSubscriptions.push(this.dialogDlr.afterClosed().subscribe(result => {
      if (result || result === '') {
        policy[editType] = result;
        this.updateDlrPolicy(editType, policy);
      }
    }));
  }

  removeSelected(){
    this.dialogConfirmation = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      disableClose: true,
      hasBackdrop: false,
      id: 'removeDlrPolicyConfirmation' + this.tabCode,
      data: {
        type: 'RemoveDlrPolicy',
        count: this.selectedCount,
        name : 'Removal Confirmation'
      }
    });

    this.dialogConfirmation.afterClosed().subscribe(result => {
      const selected = this.dataSourceDlr.data.filter((item: any) => item.selected === true);
      const ids      = selected.map((e: any) => e.id);

      this.dlrService.delete(ids).toPromise().then((response: any) => {
        if (response && response.status === 200) {
          const ap = {
            comment: 'DLR Policies have been deleted',
            oldValue: selected
          };
          this.userAuditV2Service.createAuditRecord(this.pageName, 'delete', JSON.stringify(ap));

          this.openSnackBar(['+' + 'DLR Policies have been deleted successfully']);
          this.setSubscription();
        } else {
          this.showMessage('Error deleting dlr policy!', 'Error');
        }
      });

    });
  }

  importCSVExcel() {
    const fileUpload    = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        console.log(index);
        const file = fileUpload.files[index];

        const model = {
          data: file,
          state: 'in',
          inProgress: false,
          progress: 0,
          canRetry: false,
          canCancel: true
        };

        this.uploadFiles(model);
      }


    };
    fileUpload.click();
  }



  exportExcel() {
    this.criteria.page     = 0;
    this.criteria.pageSize = 0;

    this.dlrService.exportExcel(this.criteria).toPromise().then((response: any) => {
      if (response && response.status === 200) {
        const excelFileName = 'dlr-policies_' + moment().format('YYYYMMDD-hhmmss') + '.xlsx';
        saveAs(new Blob([response.body]), excelFileName);
      } else {
        this.showMessage('Error exporting dlr policy!', 'Error');
      }
    });
  }

  saveOldValue(data: string) {
    this.savedOldValue = data;
  }

  preventWrongInput(e) {
    if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) === -1) {
      e.preventDefault();
    }
  }


  updateDlrPolicy(column: string, el: any) {
    const policy = {
      id       : el.id,
      [column] : el[column]
    };

    if (Number.isNaN(el[column]) || el[column] === null) {
      return;
    } else {
      this.dlrService.update(policy).toPromise().then((response: any) => {
        if (response && response.status === 200) {
          this.cdr.detectChanges();
          const ap = {
            comment: 'DLR Policies have been updated',
            oldValue: policy
          };
          this.userAuditV2Service.createAuditRecord(this.pageName, 'update', JSON.stringify(ap));

          this.openSnackBar(['+' + 'DLR Policies have been updated successfully']);
        } else {
          this.showMessage('Error updating dlr policy!', 'Error');
        }
      });
    }
  }

  async showMessage(mes: string, type) {
    const { InfoMessageComponent } = await import(

      '../../dialogs/info-message/info-message.component'
      );

    this.dialog.open(InfoMessageComponent, {
      width: '320px',
      disableClose: false,
      hasBackdrop: false,
      id: 'clientRatesNotes' + this.tabCode + moment().toString(),
      data: {
        infoMessage: mes,
        type
      }
    });
  }

  ngOnDestroy() {

    this.destroy$.next(true);
    // Unsubscribe from the subject
    this.destroy$.unsubscribe();

    if (this.countriesSubscription) {
      this.countriesSubscription.unsubscribe();
    }

    if (this.basicConf) {
      this.basicConf.unsubscribe();
    }

    this.filterSubscriptions.forEach(subsc => {
      subsc.unsubscribe();
    });

    this.timeouts.forEach(el => {
      if (el) {
        clearTimeout(el);
      }
    });

  }

  private _filter(value: string): any[] {
    if (value && value !== 'All' && value !== '') {
      const filterValue = value;
      const arr =  this.countries.filter(country => country.country.toLowerCase().includes(filterValue)
        || (country.mcc && country.mcc.toString().includes(filterValue)) );
      return arr;
    } else {
      return this.countries;
    }
  }

  private uploadFiles(file) {
    const formData = new FormData();
    formData.append('vm.fileUpload', file.data);
    const modelF = {
      userId   : this.userAuditV2Service.getUserID(),
      page     : 0,
      pageSize : 0,
      file     : formData
    };

    this.dlrService.uploadFile(modelF).toPromise().then((response: any) => {
      if (response && response.status === 200) {
        const ap = {
          comment: 'DLR Policies have been imported',
          oldValue: modelF
        };
        this.userAuditV2Service.createAuditRecord(this.pageName, 'insert', JSON.stringify(ap));

        this.openSnackBar(['+' + 'DLR Policies have been imported successfully']);
        this.setSubscription();
      } else {
        this.showMessage('Error importing dlr policy!', 'Error');
      }
      this.fileUpload.nativeElement.value = '';
    }).catch(err => {
      this.openSnackBar(['-' + err.error.error])
    });
  }


}
